export default __webpack_public_path__ + "static/media/rounded-rectangle-3-breaks.bb82e8c5.webp";